export const PERSONALIZATION_ID = 'personalizationID';
export const CURRENT_USER_KEY = 'currentUser';
export const PERMANENT_STORE_DAYS = 30;
export const STORE_NAME = 'HDM-B2C-Store';
export const KEY_PREFIX = `HCS`;
export const WC_TOKEN = 'WCToken';
export const WC_TRUSTED_TOKEN = 'WCTrustedToken';
export const CREATIVE_NAME_KEY = 'creative_name';
export const CREATIVE_SLOT_KEY = 'creative_slot';
export const KEY_WORDS_KEY = 'key_words';
export const LIST_PARTNUMBERS_KEY = 'list_partnumbers';
export const PROMOTION_ID_KEY = 'promotion_id';
export const PROMOTION_NAME_KEY = 'promotion_name';
export const PROMO_CART_DETAILS_KEY = 'promoCartDtls';
